export function hasPermission (permission) {
    return !!(window._permissions.find((modulePermission) => {
        return modulePermission.permission_name === permission && modulePermission.is_enabled === 1;
    }))
}
